import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=ba7ce370&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=ba7ce370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ce370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba7ce370')) {
      api.createRecord('ba7ce370', component.options)
    } else {
      api.reload('ba7ce370', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=ba7ce370&scoped=true&", function () {
      api.rerender('ba7ce370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4JxB9d7E10Hv5/JS/comp/Voucher.vue"
export default component.exports